import type { PreviewItem } from "../../hooks/useMediaLightbox";

type Props = {
  videoPreview: PreviewItem | null;
  videoPreviewVisible: boolean;
  onClose: () => void;
};

export default function VideoLightbox({
  videoPreview,
  videoPreviewVisible,
  onClose,
}: Props) {
  if (!videoPreview) return null;
  const previewUrl = videoPreview.url || "";
  const previewName = videoPreview.name || "video";

  return (
    <div className="fixed inset-0 z-[40000] flex items-center justify-center" onClick={onClose}>
      <div className={`absolute inset-0 bg-black/70 transition-opacity duration-200 ${videoPreviewVisible ? "opacity-100" : "opacity-0"}`} />
      <div
        className={`relative max-w-[92vw] max-h-[86vh] rounded-2xl overflow-hidden border border-neutral-800 shadow-2xl bg-neutral-950 transition-[opacity,transform] duration-200 ease-out transform ${
          videoPreviewVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <video
          src={previewUrl}
          className="block max-h-[86vh] max-w-[92vw] bg-black"
          controls
          autoPlay
          playsInline
          preload="metadata"
        />
        <button
          className="absolute top-2 right-2 h-9 w-9 rounded-full bg-black/50 text-fg border border-neutral-700 hover:bg-black/70 flex items-center justify-center"
          onClick={onClose}
          aria-label="Close"
          title="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className="pointer-events-none absolute bottom-2 left-2 right-2 truncate rounded bg-black/45 px-2 py-1 text-xs text-fg">
          {previewName}
        </div>
      </div>
    </div>
  );
}
